const counters = document.querySelectorAll('.animated_number__value');
const speed = 100;

counters.forEach( counter => {
	const animate = () => {
		const value = +counter.getAttribute('akhi');
		const data = +counter.innerText;
		const time = value / speed;
		if(data < value) {
			counter.innerText = Math.ceil(data + time);
			setTimeout(animate, 1);
		}else{
			counter.innerText = value;
		}
	}
	animate();
});
